import store from '@/store'

let timeoutId: number | null = null

store.commit('user/setDevice', {
  maxWidth480px: window.matchMedia('(max-width: 480px)').matches
})

window.addEventListener('resize', () => {
  if (timeoutId !== null) {
    clearTimeout(timeoutId)
  }

  timeoutId = setTimeout(() => {
    store.commit('user/setDevice', {
      maxWidth480px: window.matchMedia('(max-width: 480px)').matches
    })
  }, 50)
})
